import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSave, FaTimes, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import './Category.css';

const fetchCategories = () => {
  return [
    { categoryid: '1', categoryname: 'Books', created_at: '2023-06-01T10:00:00Z', updated_at: '2023-06-01T10:00:00Z', notes: 'Various book categories', parentcategoryid: null },
    { categoryid: '2', categoryname: 'Electronics', created_at: '2023-06-02T11:00:00Z', updated_at: '2023-06-02T11:00:00Z', notes: 'Electronic devices and accessories', parentcategoryid: null },
    { categoryid: '3', categoryname: 'Smartphones', created_at: '2023-06-02T11:00:00Z', updated_at: '2023-06-02T11:00:00Z', notes: 'Mobile phones', parentcategoryid: '2' },
    { categoryid: '4', categoryname: 'Laptops', created_at: '2023-06-02T11:00:00Z', updated_at: '2023-06-02T11:00:00Z', notes: 'Portable computers', parentcategoryid: '2' },
    { categoryid: '5', categoryname: 'Fiction', created_at: '2023-06-02T11:00:00Z', updated_at: '2023-06-02T11:00:00Z', notes: 'Fictional literature', parentcategoryid: '1' },
    { categoryid: '6', categoryname: 'Non-fiction', created_at: '2023-06-02T11:00:00Z', updated_at: '2023-06-02T11:00:00Z', notes: 'Non-fictional literature', parentcategoryid: '1' },
    { categoryid: '7', categoryname: 'Tablets', created_at: '2023-06-02T11:00:00Z', updated_at: '2023-06-02T11:00:00Z', notes: 'Tablet devices', parentcategoryid: '2' },
    { categoryid: '8', categoryname: 'Accessories', created_at: '2023-06-02T11:00:00Z', updated_at: '2023-06-02T11:00:00Z', notes: 'Electronic accessories', parentcategoryid: '2' },
    { categoryid: '9', categoryname: 'Biographies', created_at: '2023-06-02T11:00:00Z', updated_at: '2023-06-02T11:00:00Z', notes: 'Biographical books', parentcategoryid: '6' },
  ];
};

const Category = () => {
  const [categories, setCategories] = useState([]);
  const [editingCategory, setEditingCategory] = useState(null);
  const [newCategory, setNewCategory] = useState({ categoryname: '', notes: '', parentcategoryid: '' });
  const [expandedCategories, setExpandedCategories] = useState({});

  useEffect(() => {
    setCategories(fetchCategories());
  }, []);

  const handleEdit = (category) => {
    setEditingCategory(category);
  };

  const handleDelete = (categoryid) => {
    setCategories(categories.filter(category => category.categoryid !== categoryid));
  };

  const handleSave = (categoryid, updatedCategory) => {
    setCategories(categories.map(category =>
      category.categoryid === categoryid ? { ...category, ...updatedCategory, updated_at: new Date().toISOString() } : category
    ));
    setEditingCategory(null);
  };

  const handleAdd = () => {
    const timestamp = new Date().toISOString();
    const addedCategory = {
      categoryid: Date.now().toString(),
      ...newCategory,
      created_at: timestamp,
      updated_at: timestamp
    };
    setCategories([...categories, addedCategory]);
    setNewCategory({ categoryname: '', notes: '', parentcategoryid: '' });
  };

  const toggleExpand = (categoryid) => {
    setExpandedCategories(prev => ({ ...prev, [categoryid]: !prev[categoryid] }));
  };

  const renderCategoryTree = (parentId = null) => {
    return (
      <div className="category-grid">
        {categories
        .filter(category => parentId === null ? (category.parentcategoryid === null || category.parentcategoryid === '') : category.parentcategoryid === parentId)
        .map(category => (
            <div key={category.categoryid} className="category-card">
              {editingCategory && editingCategory.categoryid === category.categoryid ? (
                <div className="category-edit-form">
                  <input
                    value={editingCategory.categoryname}
                    onChange={(e) => setEditingCategory({...editingCategory, categoryname: e.target.value})}
                    placeholder="Category name"
                    className="category-edit-input"
                  />
                  <textarea
                    value={editingCategory.notes}
                    onChange={(e) => setEditingCategory({...editingCategory, notes: e.target.value})}
                    placeholder="Notes"
                    className="category-edit-textarea"
                  />
                  <select
                    value={editingCategory.parentcategoryid || ''}
                    onChange={(e) => setEditingCategory({...editingCategory, parentcategoryid: e.target.value || null})}
                    className="category-edit-select"
                  >
                    <option value="">No parent</option>
                    {categories.filter(c => c.categoryid !== category.categoryid).map(c => (
                      <option key={c.categoryid} value={c.categoryid}>{c.categoryname}</option>
                    ))}
                  </select>
                  <div className="category-edit-actions">
                    <button onClick={() => handleSave(category.categoryid, editingCategory)} className="category-save-btn"><FaSave /> Save</button>
                    <button onClick={() => setEditingCategory(null)} className="category-cancel-btn"><FaTimes /> Cancel</button>
                  </div>
                </div>
              ) : (
                <>
                  <div className="category-info">
                    <h3 className="category-name">
                      {category.categoryname}
                      {categories.some(c => c.parentcategoryid === category.categoryid) && (
                        <button onClick={() => toggleExpand(category.categoryid)} className="category-expand-btn">
                          {expandedCategories[category.categoryid] ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                      )}
                    </h3>
                    <p className="category-notes">{category.notes}</p>
                    <small className="category-updated">Last updated: {new Date(category.updated_at).toLocaleString()}</small>
                  </div>
                  <div className="category-actions">
                    <button onClick={() => handleEdit(category)} className="category-edit-btn"><FaEdit /></button>
                    <button onClick={() => handleDelete(category.categoryid)} className="category-delete-btn"><FaTrash /></button>
                  </div>
                </>
              )}
              {expandedCategories[category.categoryid] && (
                <div className="category-subcategories">
                  {renderCategoryTree(category.categoryid)}
                </div>
              )}
            </div>
          ))}
      </div>
    );
  };

  return (
  <div> 
      <div className="category-header-container">
        <h2 className="category-header">Categories</h2>
      </div>

    <div className="category-container">


      {renderCategoryTree()}
      <div className="category-add-form">
        <h3 className="category-add-header">Add New Category</h3>
        <input
          placeholder="New category name"
          value={newCategory.categoryname}
          onChange={(e) => setNewCategory({...newCategory, categoryname: e.target.value})}
          className="category-add-input"
        />
        <textarea
          placeholder="Notes"
          value={newCategory.notes}
          onChange={(e) => setNewCategory({...newCategory, notes: e.target.value})}
          className="category-add-textarea"
        />
        <select
          value={newCategory.parentcategoryid}
          onChange={(e) => setNewCategory({...newCategory, parentcategoryid: e.target.value || null})}
          className="category-add-select"
        >
          <option value="">No parent</option>
          {categories.map(category => (
            <option key={category.categoryid} value={category.categoryid}>{category.categoryname}</option>
          ))}
        </select>
        <button onClick={handleAdd} className="category-add-btn"><FaPlus /> Add Category</button>
      </div>
    </div>
  </div>
  );

};

export default Category;

